import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';

const ScrollReveal = ({ children, direction = 'up', delay = 0, duration = 0.5 }) => {
  const reduceMotion = useReducedMotion();

  const variants = reduceMotion
    ? {
        hidden: { opacity: 0 },
        visible: { opacity: 1, transition: { duration: 0 } },
      }
    : {
        hidden: {
          opacity: 0,
          y: direction === 'up' ? 24 : direction === 'down' ? -24 : 0,
          x: direction === 'left' ? 24 : direction === 'right' ? -24 : 0,
        },
        visible: {
          opacity: 1,
          y: 0,
          x: 0,
          transition: {
            duration: duration,
            delay: delay,
            ease: [0.25, 0.1, 0.25, 1],
          },
        },
      };

  return (
    <motion.div
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, margin: "-100px" }}
      variants={variants}
      style={{ height: '100%' }}
    >
      {children}
    </motion.div>
  );
};

export default ScrollReveal;
